import uuid from "uuid"
import database from "../firebase/firebase"

/*
// ADD_EXPENSE
export const importExpense = (metadata) => ({
  type: 'IMPORT_EXPENSE',
  metadata
});

export const startImportExpense = (expenseData = {}) => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid

    const {
      account = '',
      accountId = '',
      type = '',
      url = '',
      source = '',
      processing = false,
      processed = false
    } = expenseData.data

    const {
      fname = '',
      lname = '',
      email = '',
      bucketUrl = ''
    } = expenseData

    // const {
    //   description = '',
    //   label = '',
    //   note = '',
    //   amount = 0,
    //   createdAt = 0
    // } = expenseData;
    const name = `${fname} ${lname}`
    //const metadata = { fname, lname, email, bucketUrl };
    const postDate = new Date()
    const metadata1 = {
      name,
      type,
      bucket: '',
      uploadDate: 12,
      source,
      uid,
      processing,
      processed,
      bucketUrl
    };

    console.log("metadata: ", metadata1)
    return database.ref(`users/${uid}/imports`).push(metadata1).then((ref) => {
      dispatch(importExpense({
        id: ref.key,
        ...metadata
      }));
    });
  };
};

*/

// ADD_EXPENSE
export const addExpense = (expense) => ({
  type: "ADD_EXPENSE",
  expense,
})

export const startAddExpense = (expenseData = {}) => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    const { description = "", label = "", note = "", amount = 0, createdAt = 0 } = expenseData
    const expense = { description, label, note, amount, createdAt }

    return database
      .ref(`users/${uid}/expenses`)
      .push(expense)
      .then((ref) => {
        dispatch(
          addExpense({
            id: ref.key,
            ...expense,
          })
        )
      })
  }
}

// REMOVE_EXPENSE
export const removeExpense = ({ id } = {}) => ({
  type: "REMOVE_EXPENSE",
  id,
})

// EDIT_EXPENSE
export const editExpense = (id, updates) => ({
  type: "EDIT_EXPENSE",
  id,
  updates,
})

// SET_EXPENSES
export const setExpenses = (expenses) => ({
  type: "SET_EXPENSES",
  expenses,
})

const parseResultsToExpenses = (snapshot) => {
  const expenses = []
  snapshot.forEach((child) => {
    expenses.push({
      id: child.key,
      ...child.val(),
    })
  })

  return expenses
}

// db.ref().update({
//     stressLevel: 9,
//     'job/company': 'Amazon',
//     'location/city': 'Seattle',
//     'location/state': 'Washington'
// })

//startEditExpense
export const startEditExpense = (id, updates) => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    return database
      .ref(`users/${uid}/expenses/${id}`)
      .update({
        ...updates,
      })
      .then(() => {
        dispatch(editExpense(id, updates))
      })
  }
}

// course solution
export const startRemoveExpense = ({ id } = {}) => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    return database
      .ref(`users/${uid}/expenses/${id}`)
      .remove()
      .then(() => {
        dispatch(removeExpense({ id }))
      })
  }
}

//my solution - worked
// export const startRemoveExpense = (({ id }) => {
//   return (dispatch) => {
//     return database.ref(`expenses/${id}`).remove()
//       .then(() => {
//         dispatch(removeExpense({ id }));
//       }).catch((e) => {
//         console.log('Fetch Error: ', e)
//       })

//   }

// })

export const startSetExpenses = () => {
  return (dispatch, getState) => {
    const uid = getState().auth.uid
    return database
      .ref(`users/${uid}/expenses`)
      .once("value")
      .then((snapshot) => {
        const expenses = parseResultsToExpenses(snapshot)
        dispatch(setExpenses(expenses))
      })
      .catch((e) => {
        console.log("Fetch Error: ", e)
      })
  }
}

// export const startAddExpense = (expenseData = {}) => {
//   return (dispatch) => {
//     const {
//       description = '',
//       note = '',
//       amount = 0,
//       createdAt = 0
//     } = expenseData;
//     const expense = { description, note, amount, createdAt };

//     return database.ref('expenses').push(expense).then((ref) => {
//       dispatch(addExpense({
//         id: ref.key,
//         ...expense
//       }));
//     });
//   };
// };



// WEBPACK FOOTER //
// ./src/actions/expenses.js